import axios from 'axios'

export const postExtract = () =>
    axios.post(`${window.URL_API_USER}wallet/extract`)

export const postReport = () =>
    axios.post(`${window.URL_API_USER}wallet/report`)

export const postCashOut = (amount, bank) =>
    axios.post(`${window.URL_API_USER}wallet/cash-out`, {amount, bank})


// WEBPACK FOOTER //
// ./src/App/utils/billing.js